import {MantineProvider} from '@mantine/core'
import {Notifications} from '@mantine/notifications'
import {MutationCache, QueryCache, QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {createRootRoute, Outlet} from '@tanstack/react-router'

import {UnauthorizedError} from '../api/errors'
import {clearStoredUser} from '../lib/auth'
import {cssVariablesResolver, theme} from '../theme'

function handleGlobalError(error: Error) {
    if (error instanceof UnauthorizedError) {
        clearStoredUser()
        window.location.href = '/login'
    }
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Intermittent errors are rare enough that we don't need to handle
            // them with retries, and retrying requests that fail due to bugs is
            // a waste of resources and increases complexity unnecessarily.
            staleTime: Infinity,
            retry: false,
        },
    },
    queryCache: new QueryCache({onError: handleGlobalError}),
    mutationCache: new MutationCache({onError: handleGlobalError}),
})

export const Route = createRootRoute({
    component: RootComponent,
})

function RootComponent() {
    return (
        <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver}>
            <Notifications />
            <QueryClientProvider client={queryClient}>
                <Outlet />
            </QueryClientProvider>
        </MantineProvider>
    )
}
